import { a as r } from "./array-slice-simple.js";
var t = Math.floor,
  a = function a(e, f) {
    var l = e.length,
      i = t(l / 2);
    return l < 8 ? n(e, f) : o(e, a(r(e, 0, i), f), a(r(e, i), f), f);
  },
  n = function n(r, t) {
    for (var a, n, o = r.length, e = 1; e < o;) {
      for (n = e, a = r[e]; n && t(r[n - 1], a) > 0;) r[n] = r[--n];
      n !== e++ && (r[n] = a);
    }
    return r;
  },
  o = function o(r, t, a, n) {
    for (var o = t.length, e = a.length, f = 0, l = 0; f < o || l < e;) r[f + l] = f < o && l < e ? 0 >= n(t[f], a[l]) ? t[f++] : a[l++] : f < o ? t[f++] : a[l++];
    return r;
  },
  e = a;
export { e as a };